import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../Wrapper';
import useBreakpointRef from '../../../hooks/useBreakpointRef';

const BREAKPOINTS = Object.freeze([736, 744, 1128, 1512]);
const BREAKPOINT_VALUES = Object.freeze([
  {
    maxWidth: '360px',
    cardMargin: 'small'
  },
  {
    maxWidth: '736px',
    cardMargin: 'small'
  },
  {
    maxWidth: '744px',
    cardMargin: 'standard'
  },
  {
    maxWidth: '1128px',
    cardMargin: 'standard'
  },
  {
    maxWidth: '1512px',
    cardMargin: 'standard'
  }
]);
const CONTAINER_STYLE = Object.freeze({
  display: 'flex',
  flexDirection: 'row',
  width: '100%'
});

const DisplayWidthForCards = ({ children, threeCardMax }) => {
  const { ref, breakpointValue } = useBreakpointRef({
    breakpoints: threeCardMax ? BREAKPOINTS.slice(0, 3) : BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES
  });

  return (
    <Wrapper>
      <div ref={ref} style={CONTAINER_STYLE}>
        {breakpointValue ?
          <div style={{ margin: '0 auto', width: '100%', maxWidth: breakpointValue.maxWidth }}
            className={`${breakpointValue.cardMargin}-card-margin`}>
            {children}
          </div>
          : null}
      </div>
    </Wrapper>
  );
};

DisplayWidthForCards.propTypes = {
  children: PropTypes.node,
  threeCardMax: PropTypes.bool
};

export default DisplayWidthForCards;
